import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { GMCommonConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { GradeMatrixCommonService } from './api/gradeMatrixCommon.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class GMCommonApiModule {
    public static forRoot(configurationFactory: () => GMCommonConfiguration): ModuleWithProviders<GMCommonApiModule> {
        return {
            ngModule: GMCommonApiModule,
            providers: [ { provide: GMCommonConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: GMCommonApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('GMCommonApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
